document.addEventListener('DOMContentLoaded', function () {

  // Dropdown "Meni" toggle (nav)
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var dropdown = document.querySelector('[data-menu-dropdown]');
      if (dropdown) dropdown.classList.toggle('is-open');
    });
  });
  document.querySelectorAll('[data-menu-close]').forEach(function (link) {
    link.addEventListener('click', function () {
      var dropdown = document.querySelector('[data-menu-dropdown]');
      if (dropdown) dropdown.classList.remove('is-open');
    });
  });
  document.addEventListener('click', function (e) {
    var dropdown = document.querySelector('[data-menu-dropdown]');
    var toggle = document.querySelector('[data-menu-toggle]');
    if (!dropdown || !dropdown.classList.contains('is-open')) return;
    if (dropdown.contains(e.target) || (toggle && toggle.contains(e.target))) return;
    dropdown.classList.remove('is-open');
  });

  // Contact form: front-end only "thank you" state (no email is sent)
  var form = document.querySelector('[data-contact-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var wrap = document.querySelector('[data-form-wrap]');
      var success = document.querySelector('[data-form-success]');
      if (wrap) wrap.style.display = 'none';
      if (success) success.classList.add('is-visible');
    });
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  // Hero: mouse-driven depth/parallax
  window.addEventListener('pointermove', function (e) {
    document.querySelectorAll('[data-scene]').forEach(function (scene) {
      var r = scene.getBoundingClientRect();
      var dx = (e.clientX - (r.left + r.width / 2)) / r.width;
      var dy = (e.clientY - (r.top + r.height / 2)) / r.height;
      scene.style.setProperty('--rx', (-dy * 4.5).toFixed(2) + 'deg');
      scene.style.setProperty('--ry', (dx * 7).toFixed(2) + 'deg');
      scene.querySelectorAll('[data-depth]').forEach(function (el) {
        var d = parseFloat(el.getAttribute('data-depth')) || 0;
        el.style.setProperty('--px', (dx * d * 12).toFixed(1) + 'px');
        el.style.setProperty('--py', (dy * d * 12).toFixed(1) + 'px');
      });
    });
  }, { passive: true });

  // Card tilt on pointer proximity
  var tiltEls = Array.prototype.slice.call(document.querySelectorAll('[data-tilt]'));
  window.addEventListener('pointermove', function (e) {
    tiltEls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var pad = 40;
      if (e.clientX < r.left - pad || e.clientX > r.right + pad || e.clientY < r.top - pad || e.clientY > r.bottom + pad) {
        el.style.setProperty('--tx', '0deg');
        el.style.setProperty('--ty', '0deg');
        return;
      }
      var dx = (e.clientX - (r.left + r.width / 2)) / r.width;
      var dy = (e.clientY - (r.top + r.height / 2)) / r.height;
      el.style.setProperty('--ty', (dx * 6).toFixed(2) + 'deg');
      el.style.setProperty('--tx', (-dy * 6).toFixed(2) + 'deg');
    });
  }, { passive: true });

  // Scroll-driven reveal + depth parallax
  var revealEls = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
  var parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-depth-scroll]'));
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      revealEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var startAt = vh * 0.88;
        var endAt = vh * 0.32;
        var p = (startAt - r.top) / (startAt - endAt);
        p = Math.max(0, Math.min(1, p));
        el.style.setProperty('--reveal', p.toFixed(3));
      });
      parallaxEls.forEach(function (el) {
        var d = parseFloat(el.getAttribute('data-depth-scroll')) || 1;
        var r = el.getBoundingClientRect();
        var offset = r.top + r.height / 2 - vh / 2;
        var frac = offset / vh;
        el.style.setProperty('--sy', (frac * d * -34).toFixed(1) + 'px');
        el.style.setProperty('--srz', (frac * d * -0.8).toFixed(2) + 'deg');
      });
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
});
